import React from 'react';
import config from '@/configs/config';
import {
  includes,
  isEmpty,
  isEqual, keys, map, omitBy, size, sortBy,
} from 'lodash';
import moment from 'moment';
import { StyledCheckbox } from './Item';
import NumberField from './NumberField';

export default function LocationGroup({
  addItem,
  data,
  disabled,
  onItemCheckboxChange,
  onLocationCheckboxChange,
  readOnly,
  removeItem,
  selectedItemIds,
  setIsRemoveProductModalOpened,
  setItemIdToDelete,
  note,
}) {
  const {
    id, itemDict, name, description,
  } = data;

  return (
    <div key={id} className="fz-flex fz-flex-col">
      <div className="fz-flex fz-p-2 fz-items-center fz-gap-x-1">
        { readOnly ? null : (
          <div className="fz-flex-shrink-0">
            <StyledCheckbox
              onChange={onLocationCheckboxChange}
              disabled={disabled || isEmpty(omitBy(itemDict, ['disabled', true]))}
              checked={
                !isEmpty(selectedItemIds)
                && isEqual(
                  sortBy(selectedItemIds),
                  sortBy(keys(omitBy(itemDict, ['disabled', true])))
                )
              }
              value={id}
            />
          </div>
        )}
        <div className="fz-flex fz-flex-col">
          <span className="fz-font-bold">{name}</span>
          <span className="fz-text-onSale fz-text-xs">{description}</span>
        </div>
      </div>
      <div className="fz-border-0 fz-border-t fz-border-solid fz-border-gray-100">
        {map(itemDict, (product, itemId) => {
          const {
            name: productName,
            productNumber,
            disabled: productDisabled,
            price,
            sellPrice,
            items,
            redeemStartTime,
            redeemEndTime,
          } = product || {};
          const amount = size(items);
          const redeemStartString = moment(redeemStartTime).format('MM/DD HH:mm');
          const redeemEndString = moment(redeemEndTime).format('MM/DD HH:mm');

          return (
            <div key={itemId} className="fz-flex fz-gap-x-1 fz-p-2 fz-items-center">
              { readOnly ? null : (
                <div className="fz-flex-shrink-0">
                  <StyledCheckbox
                    disabled={productDisabled || disabled}
                    onChange={onItemCheckboxChange}
                    value={itemId}
                    checked={includes(selectedItemIds, itemId)}
                  />
                </div>
              )}
              <img
                className={`
                  fz-aspect-square
                  fz-shrink-0
                  fz-h-[80px]
                  ${readOnly ? 'fz-block' : 'fz-hidden'}
                  sm:fz-block
                  sm:fz-h-[100px]
                `}
                src={`${config.RESOURCE_URI}/ProductImages/${productNumber}.jpg`}
                alt=""
                onError={(e) => {
                  e.currentTarget.src = `${config.RESOURCE_URI}provider_default.png`;
                }}
              />
              <div className="fz-flex fz-flex-col fz-justify-between fz-grow fz-self-stretch fz-text-sm sm:fz-text-base">
                <span>{productName}</span>
                <div className="fz-flex fz-flex-col fz-text-onSale fz-text-xs">
                  <span>取貨時間</span>
                  <span>{`${redeemStartString} ~ ${redeemEndString}`}</span>
                  <span>(實際取貨時間請以LINE 貨到通知為準)</span>
                </div>
              </div>
              <div className="fz-flex-shrink-0 fz-text-center fz-flex fz-flex-col fz-gap-y-1">
                <div>
                  <span className={`
                    ${price !== sellPrice && 'fz-text-xs'}
                    ${price !== sellPrice && 'fz-line-through'}
                    ${price !== sellPrice && 'fz-text-gray-400'}
                  `}
                  >
                    {`$${price}`}
                  </span>
                  {price !== sellPrice && (
                    <span className="fz-ml-1 fz-text-onSale">{`$${sellPrice}`}</span>

                  )}
                  {readOnly ? (
                    <span className="fz-text-xs">{` x ${amount}`}</span>
                  ) : null}
                </div>
                { readOnly ? null : (
                  <NumberField
                    value={amount}
                    min={0}
                    onChange={(newValue) => {
                      const diff = newValue - parseInt(amount, 10);

                      if (newValue === 0) {
                        setIsRemoveProductModalOpened(true);
                        setItemIdToDelete(itemId);
                      } else if (diff > 0) {
                        addItem({ ...items[0] });
                      } else if (diff < 0) {
                        removeItem([items[0]]);
                      }
                    }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
      {note && (
        <div className="fz-border-0 fz-border-t fz-border-solid fz-border-gray-100 fz-p-2 fz-text-onSale fz-text-xs">
          {note}
        </div>
      )}
    </div>
  );
}
